var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.487,
    height: 20.45,
    viewBox: "0 0 40.487 40.45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_686",
    "data-name": "Grupo 686",
    transform: "translate(-3833.963 -3627.712)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 13.224,
    cy: 13.224,
    r: 13.224,
    transform: "translate(3834.963 3628.713)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M3848.057,3643.2l-.056-7.961",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_81",
    "data-name": "Linha 81",
    x2: 6.863,
    transform: "translate(3848.001 3643.203)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_82",
    "data-name": "Linha 82",
    y2: 2.197,
    transform: "translate(3848.189 3628.712)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_83",
    "data-name": "Linha 83",
    y2: 2.177,
    transform: "translate(3848.189 3652.891)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_84",
    "data-name": "Linha 84",
    x1: 2.209,
    transform: "translate(3834.963 3642.938)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_85",
    "data-name": "Linha 85",
    x1: 2.299,
    transform: "translate(3859.151 3642.938)",
    fill: "none",
    stroke: "#939598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.0f4b859c.svg";
export { ForwardRef as ReactComponent };